export default __webpack_public_path__ + "static/media/blog_detail2.be4a77ca.jpg";